import d3 from '../box';
import iqr from './iqr';

const displayBoxPlot = (data) => {
  
  let labels = true; // show the text labels beside individual boxplots?

  let margin = {top: 30, right: 30, bottom: 80, left: 80};
  let width = 800 - margin.left - margin.right;
  let height = 380 - margin.top - margin.bottom;

    
  let min = Infinity,
      max = -Infinity;
    
  for(let i=0; i<  data.length; i++){
    let arrayMax = d3.max(data[i]);
    let arrayMin = d3.min(data[i]);
    if (arrayMax > max) max = arrayMax;
    if (arrayMin < min) min = arrayMin;
  }

  // add labels in first row
  let namedMatrix = [];
  for(let i=0; i<  data.length; i++){
    let tmpArray = [];
    tmpArray.push(document.getElementById("timeSliceSelector").options[i].text);
    tmpArray.push(data[i]);
    namedMatrix.push(tmpArray);
  }
  
  let chart = d3.box()
    .whiskers(iqr(1.5))
    .height(height)  
    .domain([min, max])
    .showLabels(labels);

  document.getElementById('largeboxplot').innerHTML = '';
  let svg = d3.select("#largeboxplot")
    .append("svg")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
    .attr("class", "boxplot")    
    .append("g")
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

  /************************  
    x axis
  *************************/

  let x = d3.scaleBand()
    .rangeRound([0 , width])
    .padding(0.7, 0.3)
    .domain( namedMatrix.map((d) => { return d[0] } ) );     

  let xAxis = d3.axisBottom(x);

  // Add title to x axis
  svg.append("g")
    .attr("class", "x axis")
    .attr("transform", "translate(0," + (height  + margin.top + 10) + ")")
    .call(xAxis)
    .append("text")             // text label for the x axis
    .attr("x", (width / 2) )
    .attr("y",  25 )
    .attr("dy", ".71em")
    .style("text-anchor", "middle")
    .style("font-size", "12px")
    .style("font-weight", "bold")
    .style("fill", "currentColor")
    .text("Period");

  /************************  
    y axis
  *************************/

  let y = d3.scaleLinear()
    .domain([min, max])
    .range([height + margin.top, 0 + margin.top]);

  let yAxis = d3.axisLeft(y).ticks(5);

  // Add title to y axis
  svg.append("g")
    .attr("class", "y axis")
    .call(yAxis)
    .append("text")
    .attr("transform", "rotate(-90)")
    .attr("y", 6)
    .attr("dy", ".71em")
    .style("text-anchor", "end")
    .style("font-size", "16px");
    //.text("Revenue in €");  

  /************************  
    Draw the boxplots
  *************************/ 

  svg.selectAll(".boxplot")     
    .data(namedMatrix)
    .enter().append("g")
    .attr("transform", (d) => { return "translate(" +  x(d[0])  + "," + margin.top + ")"; } )
    .call(chart.width(x.bandwidth())); 

  // add a title
  /*svg.append("text")
    .attr("x", (width / 2))             
    .attr("y", 0 + (margin.top / 2))
    .attr("text-anchor", "middle")  
    .style("font-size", "18px")
    //.style("text-decoration", "underline")  
    .text("Revenue 2012");*/

}

export default displayBoxPlot;
